import { ReactNode } from 'react'
import classnames from 'classnames'
import StepTitle from './StepTitle'
import StepBody from './StepBody'
import StepFooterButton from './StepFooterButton'
import StepHeaderNavSection from './StepHeaderNavSection'

import styles from './Step.module.scss'
export interface StepProps {
  stepLabel: string
  className?: string
  children: ReactNode
}

const Step = ({ stepLabel, children, className }: StepProps) => (
  <div data-qa={stepLabel} className={classnames(styles.step, className)}>
    {children}
  </div>
)

Step.Title = StepTitle
Step.Body = StepBody
Step.FooterButton = StepFooterButton
Step.HeaderNavSection = StepHeaderNavSection

export default Step
